---
title: "Package Lifecycle"
slug: package-lifecycle
description: "From in transit to settled: the four phases a package goes through when sent to an external recipient."
keywords:
  - lifecycle
  - package
  - in transit
  - invoice
  - return
  - recipient
  - reminder
---

## The lifecycle of a package at an external recipient

Once you send a package to an external location, it automatically passes through four phases. hey circle monitors this process and sends reminders and invoices without any manual action on your part.

## Phase 1: In Transit

The package has been scanned and sent to the external recipient. It is outside your internal stock with the status **"In Transit"**.

During this phase, the package is with the recipient. It is neither lost nor billed — you are simply waiting for its return.

## Phase 2: Recipient Reminded

If the package has not been returned after a set period, hey circle automatically sends a **reminder notification** to the recipient.

The reminder informs them that the package is due for return. As an Admin or Manager, you are also notified in the overview of which packages are overdue.

## Phase 3: Invoice Sent

If the recipient still does not return the package, hey circle automatically creates an **invoice** and sends it. The invoice covers the usage period or the flat rate for the package, depending on your contract settings.

You can track the status in the Analytics view.

## Phase 4: Paid and Removed from Inventory

Once the invoice is settled (or the package is finally returned), the status changes to **"Completed"**. The package is removed from the outstanding inventory.

If the package is returned (scanned in at an internal location), the invoicing process is stopped and the package reverts to **"Available"** status.

## Summary at a glance

| Phase | Status | What happens |
|---|---|---|
| 1 | In Transit | Package with external recipient |
| 2 | In Transit (reminder sent) | Automatic reminder dispatched |
| 3 | In Transit (invoice sent) | Automatic invoice issued |
| 4 | Completed | Paid or returned |

## Related Articles

- [Internal vs. External Locations](/app/help?article=internal-vs-external-locations)
- [How Inventory Works](/app/help?article=how-inventory-works)
- [Reading the Analytics Dashboard](/app/help?article=viewing-analytics)
